import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REQUEST_PAYOUT_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.REQUEST_PAYOUT_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.REQUEST_PAYOUT_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.REQUEST_PAYOUT_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.REQUEST_PAYOUT_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
